import { useState, useEffect, useRef } from 'react';
import { jaJP } from '@mui/x-data-grid';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from '../../../apis/ApiRequests';
import { CustomDataGrid } from '../../../components/dataGrid/CustomDataGrid';
import CustomSnackBar from '../../../components/alert/CustomSnackBar';
import Header from '../../../components/uiParts/hygiene/Header';
import TitleBar from '../../../components/uiParts/TitleBar';
import Frame from '../../../components/uiParts/Frame';

const SensorConfig = () => {
    
    const { authInfo, setAuthInfo } = useAuth();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    
	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 160);
    const [ dataList, setDataList ] = useState([]);
    const [ searchCount, setSearchCount ] = useState(0);
    const [ openSnackBarTrue, setOpenSnackBarTrue  ] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getDataByHygieneAqualium / system_Config
	//-----------------------------------------------
    const { response : searchData_Res, loading : searchData_Loading, post:searchData_Post } = usePost();
    const searchData = async () => {
        const postData = {
            'className'    : 'mch.models.system.Config',
            'methodName'   : 'getDataByHygieneAqualium',
            'facilityCode' : facilityCode,
            'userId'       : userId,
        }
        await searchData_Post(postData);
    };
	//-----------------------------------------------
    // API - setDataByHygieneAqualium / system_Config
	//-----------------------------------------------
    const { response : setData_Res, loading : setData_Loading, post:setData_Post } = usePost();
    const setData = async (registerData) => {
        const postData = {
            'className'    : 'mch.models.system.Config',
            'methodName'   : 'setDataByHygieneAqualium',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'tankNo'       : registerData.tankNo,
            'sensorType'   : registerData.sensorType,
            'upperValue'   : registerData.upperValue ?? '',
            'rowerValue'   : registerData.rowerValue ?? '',
        }
        await setData_Post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        
        const handleResize = () => {
          setDataGridHeight(window.innerHeight - 160);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[])
	//-----------------------------------------------
    // useEffect - searchData / masta_BidPerson
	//-----------------------------------------------
    useEffect(() => {
        setDataList([]);
        if (searchData_Res) {
            setDataList(searchData_Res.Data);
        }
    }, [searchData_Res]);
	//-----------------------------------------------
    // useEffect - setData / masta_BidPerson
	//-----------------------------------------------
    useEffect(() => {
        if (setData_Res) {
            if(!isProcessing){
                handleClickSnackBarTrue();
            }
            setSearchCount(searchCount+1);
        }
    }, [setData_Res]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
    //===============================================
    // dataGird
    //===============================================
    //-----------------------------------------------
    // dataGird - テーブルの見出し
    //-----------------------------------------------
    const columns = [
        { field: 'tankNo',   headerName: '水槽No',     width: 100, columnSeparatorWidth: 1, type:'number', },
        {
            field: 'sensorType',
            headerName: 'センサー種別',
            width: 150, sortable:false,
            renderCell: (params) => (
              <div>
                {sensorTypeMapping[params.value] || params.value}
              </div>
            ),
        },
        {
            field: 'rangeType',
            headerName: '閾値種別',
            width: 150, sortable:false,
            renderCell: (params) => (
              <div>
                {rangeTypeMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'value', headerName: '値',    width: 150, columnSeparatorWidth: 1, type:'number', editable:true, },
    ];
    const sensorTypeMapping = {
        1: '水温',
        2: '酸素',
        3: 'Ph',
        4: '塩分',
    };
    const rangeTypeMapping = {
        'upper': '上限',
        'rower': '下限',
    };
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
    };
    //-----------------------------------------------
    // dataGrid - 行の更新処理
    //-----------------------------------------------
    const handleProcessRowUpdate = (newRow, oldRow) => {
        const registerData = {
            tankNo: newRow.tankNo,
            sensorType: newRow.sensorType,
            rangeType: newRow.rangeType
        }
        if (newRow.rangeType === 'upper') {
            registerData.upperValue = newRow.value;
        } else if (newRow.rangeType === 'rower') {
            registerData.rowerValue = newRow.value;
        }
            setData(registerData);
        return newRow;
    };
    //-----------------------------------------------
    // dataGrid - テンキーのクリック
    //-----------------------------------------------
    const handleCellKeyDown = (event, params) => {
    };
	//===============================================
	// UI Message
	//===============================================
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) };
    
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false);
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/hygieneMastaMenu" setEntryDate={handleChange_entryDate} />
            <div className='sensorConfig bodyContens'>
                <TitleBar title="センサー閾値設定" color="#d66a35" />
                <div className='mainContents'>
                    <Frame classname="frame" title="閾値一覧" color="#d66a35">
                        <CustomDataGrid
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                            editMode                = "row"
                            rows                    = { dataList }
                            columns                 = { columns }
                            sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                            density                 = "compact"
                            localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                            showColumnRightBorder
                            showCellRightBorder
                            initialState            = {{pagination: { paginationModel: { pageSize: 100 } },}}
                            pageSizeOptions         = {[50, 100, 150, 200]}
                            loading                 = { searchData_Loading }
                            onCellClick             = {(event) => handleClick_dataGrid(event)}
                                processRowUpdate           = {handleProcessRowUpdate}
                                onCellKeyDown              = {handleCellKeyDown}
                        />
                    </Frame>
                </div>
            </div>
            <div className='haccpList_dialog'>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
            </div>
        </>
    )
}
export default SensorConfig;